import { Button, Divider, Modal } from 'antd'
import { formatScore, formatTime } from 'general_function';
import React from 'react'
import { useNavigate } from 'react-router-dom';
import { getScoreColor } from './style_const';
import { testTypeOptions } from 'components/pages/UniversitySide/UniversityTest';

const STATUS = ["not-start", "during", "not-do", "done"];
const STATUS_TEXT = [
    "Chưa đến giờ",
    "Đang trong giờ làm",
    "Không làm bài",
    "Đã hoàn thành"
];

function considerStatus(event, now) {
    if (event.start_time.isAfter(now)) {
        return 0;
    }
    if (event.end_time.isBefore(now)) {
        return event.done > 0 ? 3 : 2;
    }
    if (event.done < event.limit) {
        return 1;
    }
    return 3;
}

const showList = [
    { label: "Môn", key: "course_name" },
    { label: "Cách tính điểm", key: "testType", render: event => testTypeOptions.find(item => item.value === event.testType).label },
    { key: "divider" },
    {
        label: "Thời gian mở", key: "start_time", render: (event) => <>
            {event.start_time.format("DD/MM/YYYY HH:mm:ss")}
        </>
    },
    {
        label: "Thời gian đóng", key: "end_time", render: (event) => <>
            {event.end_time.format("DD/MM/YYYY HH:mm:ss")}
        </>
    },
    { key: "divider" },
    { label: "Số lượng câu hỏi", key: "number_of_quizzes" },
    {
        label: "Thời gian làm bài", key: "duration_time", render: (event) => <>
            {formatTime(event.time)}
        </>
    },
    { label: "Số lần làm tối đa", key: "limit" },
    { label: "Số lần bạn đã làm", key: "done" },
    { key: "divider" },
    {
        label: "Trạng thái", key: "status", render: (event, status) => {
            return <>
                <span className={`test-status ${STATUS[status]}`}>
                    {STATUS_TEXT[status]}
                </span>
            </>
        }
    },
    {
        label: "Điểm số", key: "score", render: (event) => 
            <span style={{color: getScoreColor(event.result)
            }}>{formatScore(event.result, event.end_time, true)}</span>,
    },
]

export default function TestModal({ event, setEvent, now }) {
    const navigate = useNavigate();
    const status = event === null ? 0 : considerStatus(event, now);
    return <Modal
        open={event}
        onCancel={() => setEvent(null)}
        footer={[
            <Button key="close" onClick={() => setEvent(null)}>
                Đóng
            </Button>,
            <Button type="primary" onClick={() => navigate(`/student-test/${event.id}`)}>
                {status === 1 ? <>Vào làm bài</> : <>Xem chi tiết</>}
            </Button>,
        ]}
        title={event?.title}
    >
        {event && <div>
            {showList.map((item, index) => item.key === "divider"
                ? <Divider key={`divider_${index}`} style={{ marginBottom: 5, marginTop: 5 }} />
                : <div key={item.key}>
                    <b>{item.label}:</b> {item.render ? item.render(event, status) : event[item.key]}
                </div>)}
        </div>}
    </Modal>
}

export { considerStatus, STATUS, STATUS_TEXT }